import { useLocation, useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getCurrentPractice } from 'api/Practice';

import { getViewportPracticeId } from 'lib/helpers/viewportPath';

export const useCurrentPractice = (options = {}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const viewportPracticeId = getViewportPracticeId(pathname);

  return useQuery(
    ['currentPractice', viewportPracticeId],
    () => getCurrentPractice(navigate, options),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      ...options
    }
  );
};
